import { preloadChainsList } from "~/components/ChainCapsuleTab/ChainCapsuleTab";

export const tokenSearchLoader = () => {
    preloadChainsList();
    return true;
};
